export default {
  getTemplateList: (state) => {
    return state.template_list
  },

  getTemplateListMetaData: (state) => {
    return state.templateListMetaData
  },

  getDynamicTextList: (state) => {
    return state.dynamicTextList
  },

  getStudentList: (state) => {
    return state.studentList
  },

  getTeacherList: (state) => {
    return state.teacherList
  },

  getClassList: (state) => {
    return state.classList
  },

  getClassDetail: (state) => {
    return state.classDetail
  },

  getCourseList: (state) => {
    return state.courseList
  }
}
